import { render, staticRenderFns } from "./InstitutionalInfo.vue?vue&type=template&id=4f16aee7&scoped=true"
import script from "./InstitutionalInfo.vue?vue&type=script&lang=js"
export * from "./InstitutionalInfo.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalInfo.vue?vue&type=style&index=0&id=4f16aee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16aee7",
  null
  
)

export default component.exports